"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyComponentsMapCreator = void 0;
const legacyComponentsMapCreator = ($) => ({
    table: ($node) => {
        if (!$node.is('table')) {
            return;
        }
        const headings = $node
            .find('tr:first')
            .find('th, td')
            .toArray()
            .map((data) => $(data).text());
        const rows = $node
            .find('tr:gt(0)')
            .toArray()
            .map((row) => $(row)
            .find('td')
            .toArray()
            .map((data) => $(data).html()));
        return {
            columns: headings.length,
            rows: rows.length,
            headings,
            cells: rows,
        };
    },
    image: ($node) => {
        if ($node.is('img')) {
            return { src: $node.attr('src'), align: 'left', link: '' };
        }
        if ($node.children().length === 1 && $node.find('img').length === 1) {
            return { src: $node.find('img').attr('src'), align: 'left', link: '' };
        }
        return;
    },
    iframe: ($node) => {
        if (!$node.is('iframe')) {
            return;
        }
        const src = $node.attr('src');
        const width = parseInt($node.css('width'), 10) || parseInt($node.attr('width'), 10) || 500;
        const height = parseInt($node.css('height'), 10) || parseInt($node.attr('height'), 10) || 500;
        const scrolling = $node.attr('scrolling') || 'auto';
        if (!src.match(/youtube.com/) && !src.match(/vimeo.com/)) {
            return { url: src, width, height, align: 'left', scrolling };
        }
        return;
    },
    video: ($node) => {
        if (!$node.is('iframe')) {
            return;
        }
        const width = parseInt($node.css('width'), 10) || parseInt($node.attr('width'), 10) || 500;
        const height = parseInt($node.css('height'), 10) || parseInt($node.attr('height'), 10) || 500;
        const src = $node.attr('src');
        if (src.match(/youtube.com/) || src.match(/vimeo.com/)) {
            return { url: src, width, height, align: 'left' };
        }
        return;
    },
    code: (_$node) => {
        // todo
    },
    anchor: ($node) => {
        if (!$node.is('.kb-anchor')) {
            return;
        }
        const text = $node.text();
        const id = $node.attr('id') ||
            text
                .trim()
                .replace(/['"#!.@$,%^\\&*?()[\]\-+=:/;{}~`]/gi, '')
                .replace(/&nbsp;/g, '')
                .replace(/\s/g, '-')
                .substr(0, 25)
                .toLowerCase() + (Math.random() * 200).toFixed(0);
        return { text, id };
    },
    note: ($node) => {
        if (!$node.is('.kb-note')) {
            return;
        }
        return { html: $node.html() };
    },
    tip: ($node) => {
        if (!$node.is('.kb-tip')) {
            return;
        }
        return { html: $node.html() };
    },
    important: ($node) => {
        if (!$node.is('.kb-important')) {
            return;
        }
        return { html: $node.html() };
    },
    'step-by-step': ($node) => {
        if (!$node.is('.step-by-step-widget')) {
            return;
        }
        const steps = $node
            .children('.step')
            .toArray()
            .map((step) => {
            const $step = $(step);
            return {
                html: $step.find('.description').html(),
                imageSrc: $step.find('img').attr('src'),
            };
        });
        return {
            steps,
            layout: 'dots',
            allowCircular: $node.attr('data-allow-circular') === 'true',
        };
    },
});
exports.legacyComponentsMapCreator = legacyComponentsMapCreator;
